module.exports = __webpack_public_path__ + "static/media/filter-icon.eeda390e.svg";